import { IEquipmentStatus } from '@models/EquipmentStatus.model';

import React from 'react';
import {
  BlockText,
  Line,
} from '@components/Status/StatusList/StatusList.styles';
import { StatusBadge } from '@components/Status/AssetStatus.styles';
import { Container } from './Status.styles';

interface IStatus {
  status: IEquipmentStatus;
}

const Status = ({ status }: IStatus) => {
  return (
    <Container>
      <Line>
        <StatusBadge category={status.category} />
        <BlockText>{status.name}</BlockText>
      </Line>
    </Container>
  );
};

export { Status };
